// extracted by mini-css-extract-plugin
export default {"username":"profileHeader_username__rY7oD","userStatus":"profileHeader_userStatus__aP1LH"};